import { FC } from 'react';
import { Icons } from '../../../stories/atoms';
import { Spacing } from '../../../utils';
import { BackDropContainer, OverlayContainer, StyledIcon, StyledWrapper } from './ContainerDrawer.styles';

export type ContainerDrawerProps = {
  isOpen: boolean;
  onClose?: () => void;
  sliderContent: React.ReactNode;
  width: string;
  borderRadius?: Spacing;
};

export const ContainerDrawer: FC<React.PropsWithChildren<ContainerDrawerProps>> = ({
  isOpen,
  onClose,
  children,
  sliderContent,
  width,
  borderRadius,
}) => {
  return (
    <StyledWrapper data-testid="slider-wrapper" direction="horizontal" width="100%" wrap="nowrap" height="100%">
      {children}
      <BackDropContainer
        data-testid="backdrop-container"
        isSliderOpen={isOpen}
        onClick={() => onClose && onClose()}
        onKeyDown={() => onClose && onClose()}
        role="button"
        borderRadius={borderRadius}
        tabIndex={0}
      ></BackDropContainer>
      <OverlayContainer
        data-testid="slider-overlay"
        isSliderOpen={isOpen}
        width={width}
        borderRadius={borderRadius}
      >
        <StyledIcon
          size="small"
          data-testid="close-overlay-icon"
          icon={Icons.CLOSE}
          margin={[3]}
          onClick={() => onClose && onClose()}
        />
        {sliderContent}
      </OverlayContainer>
    </StyledWrapper>
  );
};
